import React from 'react';
import PageLayout from './PageLayout';

export default function Privacy() {
  return (
    <PageLayout title="Privacy Policy">
      <p><strong>Last updated: April 19, 2026</strong></p>
      <p>
        SMPW Scheduler is a free tool for building volunteer schedules.
        This policy explains what the app does and does not collect.
      </p>

      <h2>What we do not collect</h2>
      <p>
        SMPW Scheduler does not collect, store, or transmit any personally
        identifiable information. Specifically:
      </p>
      <ul>
        <li>No account, login, or registration is required.</li>
        <li>No names, email addresses, phone numbers, or contact information are transmitted off of your device.</li>
        <li>No analytics, advertising, or third-party tracking is used.</li>
        <li>No location, device identifier, or usage data is collected.</li>
        <li>The app requests no permissions beyond what is required to save a generated schedule image to your device when you choose to save one.</li>
      </ul>

      <h2>What stays on your device</h2>
      <p>
        Every schedule you build is created and stored locally on your
        device. When you generate a schedule image, it is produced entirely
        on-device using the html2canvas library. The image is not uploaded
        anywhere. You choose whether to save it, share it, or discard it.
      </p>

      <h2>What is transmitted</h2>
      <p>
        The only network call the app makes is to increment a single global
        counter stored in Google Firebase Realtime Database. This counter
        tracks the total number of schedules generated across all users of
        the app. It contains no information about you, your device, or the
        contents of your schedule — only an integer that increases by one
        when you press the Generate button.
      </p>

      <h2>Children's privacy</h2>
      <p>
        SMPW Scheduler does not knowingly collect information from anyone,
        including children under 13. Because the app does not collect any
        personal information, it is suitable for use by people of any age.
      </p>

      <h2>Changes to this policy</h2>
      <p>
        If this policy changes, the updated version will be posted at this
        URL with a new "Last updated" date. Material changes will also be
        noted in the app's release notes on the App Store and Play Store.
      </p>

      <h2>Contact</h2>
      <p>
        Questions about this policy?{' '}
        <a href="mailto:branleeharris@gmail.com">Email branleeharris@gmail.com</a>.
      </p>
    </PageLayout>
  );
}
